import { t } from "i18next";
import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { mapFilterChanged } from "../store/stationsSlice";

import { Map } from "./Map";

export const MapBoard = ({ clickedStationFromTable }) => {
  const dispatch = useDispatch();
  const mapFilter = useSelector((state) => state.stations.mapFilter);

  const handleChange = (event) => {
    const name = event.target && event.target.name;
    if (name) {
      const value = event.target.checked;
      // console.log(name, value)
      dispatch(mapFilterChanged({ name, value }));
    }
  };

  return (
    <div className="col l7 m12 s12 map-container">
      <Map clickedStationFromTable={clickedStationFromTable} />
      <div className="map-controller">
        {/* <div>
          <span className="label_white">설치유형<span className="hide-on-med-and-down"> 선택</span></span>
          <span className="label_white ">
            <span className="map-controller_selector">
              <label>
                <input type="checkbox" name="sensorOnGround" className="filled-in" checked={mapFilter.sensorOnGround} onChange={handleChange} />
                <span>지표형</span>
              </label>
            </span>

            <span className="map-controller_selector_2">
              <label>
                <input type="checkbox" name="sensorInBorehole" className="filled-in" checked={mapFilter.sensorInBorehole} onChange={handleChange} />
                <span>시추형</span>
              </label>
            </span>
          </span>
        </div> */}
        <div>
          <span className="label_white" style={{ height: 45 }}>
            {t("page.stations.map.sensorTypes")}
          </span>
          <span className="label_white ">
            <span className="map-controller_selector">
              <label>
                <input
                  type="checkbox"
                  name="shortperiod"
                  className="filled-in"
                  checked={mapFilter.shortperiod}
                  onChange={handleChange}
                />
                <span>{t("sensorType.shortperiod")}</span>
              </label>
            </span>
            <span className="map-controller_selector">
              <label>
                <input
                  type="checkbox"
                  name="broadband"
                  className="filled-in"
                  checked={mapFilter.broadband}
                  onChange={handleChange}
                />
                <span>{t("sensorType.broadband")}</span>
              </label>
            </span>
            <span className="map-controller_selector">
              <label>
                <input
                  type="checkbox"
                  name="accelerometer"
                  className="filled-in"
                  checked={mapFilter.accelerometer}
                  onChange={handleChange}
                />
                <span>{t("sensorType.accelerometer")}</span>
              </label>
            </span>
          </span>
        </div>
      </div>
      <br />
    </div>
  );
};
